import type { Abi } from 'viem';

import ERC20_ABI_JSON from './erc20-abi.json';
import QUESTS_ABI_JSON from './quest-abi.json';
import RAFFLE_ABI_JSON from './raffle-abi.json';

export const RAFFLE_ADDRESS =
  (import.meta.env.VITE_RAFFLE_CONTRACT as `0x${string}`) ?? ('' as `0x${string}`);
export const QUEST_ADDRESS =
  (import.meta.env.VITE_QUEST_CONTRACT as `0x${string}`) ?? ('' as `0x${string}`);
// export const TOKEN_ADDRESS =
//   (import.meta.env.VITE_TOKEN_CONTRACT as `0x${string}`) ?? ('' as `0x${string}`);

export const RAFFLE_ABI = ((RAFFLE_ABI_JSON as any).abi ?? RAFFLE_ABI_JSON) as Abi;
export const QUESTS_ABI = ((QUESTS_ABI_JSON as any).abi ?? QUESTS_ABI_JSON) as Abi;
export const ERC20_ABI = ((ERC20_ABI_JSON as any).abi ?? ERC20_ABI_JSON) as Abi;

export function assertEnv() {
  if (!RAFFLE_ADDRESS) throw new Error('Missing VITE_RAFFLE_CONTRACT');
  if (!QUEST_ADDRESS) throw new Error('Missing VITE_QUEST_CONTRACT');
  // if (!TOKEN_ADDRESS) throw new Error('Missing VITE_TOKEN_CONTRACT');
}
